import { FCI_ERROR } from "@searchui-searchforms/shared/fci";
import { fciFetch } from "@/shared/lib/fci";
import type { PersonSuggestions } from "./types";

export type GetPersonSuggestionsProps = { partialFirstName: string; partialLastName: string; treeId: string };
export const getPersonSuggestions = ({ partialFirstName, partialLastName, treeId }: GetPersonSuggestionsProps) =>
    fciFetch<PersonSuggestions>(
        `/api/person-picker/suggest/${treeId}?partialFirstName=${partialFirstName}&partialLastName=${partialLastName}&isHideVeiledRecords=true`,
        {
            fci: {
                // Typeahead suggestions for person names from a tree
                // If it fails, the user can still type names manually
                errorType: FCI_ERROR.Convenience,
                errorInfo: "getPersonSuggestions",
            },
        },
    );
